import { useEffect } from "react";
import { products } from "@/data/products";

/**
 * Injects per-route JSON-LD for the home page:
 * - WebPage / CollectionPage with mainEntity = product catalog
 * - BreadcrumbList for the home root
 * Sitewide Organization, LocalBusiness and WebSite schema already live in index.html.
 */
const HomeSchema = () => {
  useEffect(() => {
    document
      .querySelectorAll(
        "script[data-home-webpage], script[data-home-breadcrumb], script[data-home-collection]"
      )
      .forEach((s) => s.remove());

    const webpage = {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "@id": "https://rameonenergy.in/#webpage",
      url: "https://rameonenergy.in/",
      name: "Rameon Energy | Leading Industrial Evaporator & ZLD Plant Manufacturer India",
      description:
        "Rameon Energy is a leading Indian manufacturer of Zero Liquid Discharge (ZLD) plants, Multi Effect Evaporators (MEE), MVR Evaporators, Agitated Thin Film Dryers (ATFD), Thermal Strippers, Falling Film Evaporators, Nutsche Filters and Basket Centrifuges for pharmaceutical, chemical, textile and food processing industries.",
      inLanguage: "en-IN",
      isPartOf: { "@id": "https://rameonenergy.in/#website" },
      about: [
        { "@type": "Thing", name: "Zero Liquid Discharge" },
        { "@type": "Thing", name: "Multi Effect Evaporator" },
        { "@type": "Thing", name: "MVR Evaporator" },
        { "@type": "Thing", name: "Agitated Thin Film Dryer" },
        { "@type": "Thing", name: "Industrial Wastewater Treatment" },
      ],
      primaryImageOfPage: {
        "@type": "ImageObject",
        url: "https://rameonenergy.in/hero-background-desktop.webp",
      },
      publisher: { "@id": "https://rameonenergy.in/#organization" },
    };

    const breadcrumb = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Home", item: "https://rameonenergy.in/" },
      ],
    };

    const collection = {
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      "@id": "https://rameonenergy.in/#product-catalog",
      name: "Rameon Energy Industrial Wastewater Treatment Product Catalog",
      url: "https://rameonenergy.in/products",
      isPartOf: { "@id": "https://rameonenergy.in/#website" },
      mainEntity: {
        "@type": "ItemList",
        numberOfItems: products.length,
        itemListElement: products.map((p, i) => ({
          "@type": "ListItem",
          position: i + 1,
          url: `https://rameonenergy.in/products/${p.id}`,
          name: p.name,
        })),
      },
    };

    const append = (data: object, attr: string) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.setAttribute(attr, "true");
      s.textContent = JSON.stringify(data);
      document.head.appendChild(s);
    };

    append(webpage, "data-home-webpage");
    append(breadcrumb, "data-home-breadcrumb");
    append(collection, "data-home-collection");

    return () => {
      document
        .querySelectorAll(
          "script[data-home-webpage], script[data-home-breadcrumb], script[data-home-collection]"
        )
        .forEach((s) => s.remove());
    };
  }, []);

  return null;
};

export default HomeSchema;
